// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/TailorDateField/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {TailorDateField} from '@sail/ui';

export const Basic = () => (
  <TailorDateField label="Date of birth" description="Enter your birthday" />
);
